import { render, staticRenderFns } from "./ExhibitorBusinessCardDetailsList.vue?vue&type=template&id=57d20dcf&scoped=true&"
import script from "./ExhibitorBusinessCardDetailsList.vue?vue&type=script&lang=js&"
export * from "./ExhibitorBusinessCardDetailsList.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitorBusinessCardDetailsList.vue?vue&type=style&index=0&id=57d20dcf&prod&scoped=true&lang=css&"
import style1 from "./ExhibitorBusinessCardDetailsList.vue?vue&type=style&index=1&id=57d20dcf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d20dcf",
  null
  
)

export default component.exports